import Service, { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import Store from '@ember-data/store';
import LineItemModel from 'donor-elf-web/models/line-item';
import LineItemValidations from 'donor-elf-web/validations/line-item';
import lookupValidator from 'ember-changeset-validations';
import CampaignService from './campaign-service';
import Changeset from 'ember-changeset';

export interface LineItemInfo {
  model: LineItemModel;
  changeset: any;
  campaignLineItemChangeset?: any;
}

export default class TransactionsService extends Service {
  @service declare campaignService: CampaignService;
  @service declare store: Store;

  @tracked lineItemInfos: LineItemInfo[] = [];

  addLineItemInfo() {
    let lastTransDate =
      this.lineItemInfos[this.lineItemInfos.length - 1]?.changeset?.get(
        'transDate',
      );
    if (lastTransDate == null) {
      lastTransDate = new Date();
    }
    let model = this.store.createRecord('line-item', {
      transDate: lastTransDate,
    });
    let changeset = new Changeset(
      model,
      lookupValidator(LineItemValidations),
      LineItemValidations,
    );

    const campaignLineItemChangeset = this.campaignService.campaignsEnabled
      ? new Changeset(this.store.createRecord('campaign-line-item'))
      : null;

    let info = { model, changeset, campaignLineItemChangeset };
    this.lineItemInfos = [...this.lineItemInfos, info];
    return info;
  }

  createInfoFromModel(model: LineItemModel) {
    let changeset = new Changeset(
      model,
      lookupValidator(LineItemValidations),
      LineItemValidations,
    );

    const campaignLineItemChangeset = this.campaignService.campaignsEnabled
      ? new Changeset(
          model.campaignLineItemsArray?.length > 0
            ? model.campaignLineItemsArray[0]
            : this.store.createRecord('campaign-line-item'),
        )
      : null;

    return { model, changeset, campaignLineItemChangeset };
  }
}
